import React, { FC, useState } from 'react';
import ReactPlayer from 'react-player';

import Container from '../../layout/Container';
import Icon from '../Icon';

import { ISingleVideo } from './interfaces';

import './styles.scss';

// video
const SingleVideo: FC<ISingleVideo> = ({
  value: {
    image,
    url
  }
}) => {
  const [ pause, setPause ] = useState<boolean>(false);

  // render
  return (
    <div
      className="single-video"
      data-active={pause}>
      <Container>
        <div className="single-video--container">
          <button
            className="btn single-video--image"
            onClick={() => setPause(!pause)}>
            <Icon icon="icon-video" />

            <img
              className="single-video--image--img"
              src={image?.large.src}
              alt="" />
          </button>

          <ReactPlayer
            className="single-video--video"
            height={480}
            width={854}
            playing={pause}
            url={url}
            onEnded={() => setPause(false)} />
        </div>
      </Container>
    </div>
  );
};

export default SingleVideo;